import './index.scss'
import { Link } from 'react-router-dom'
import { skills } from '../../data/skills'
import cvFile from '../../assets/CV/Master CV.pdf'

const AboutPage = () => {

  return (
    <main className="about-page">
      <div className="site-container">
      <section className="about-hero">
        <div className="about-hero__content">
          <p className="eyebrow">About Me</p>
          <h1>Christian Turner-Jones</h1>
          <h2>Computer Science Graduate — AI, systems and full-stack development</h2>
          <p>
            I am a BSc Computer Science graduate from the University of Birmingham (2:1). I build practical software that combines strong engineering foundations with applied machine learning and natural language processing. My work spans backend systems, web applications and data science pipelines.
          </p>
          <div className="about-hero__actions">
            <a href={cvFile} className="btn btn--primary" download>Download CV</a>
            <Link to="/contact" className="btn btn--secondary">Contact</Link>
          </div>
        </div>
      </section>

      <section className="about-grid">
        <div className="about-main">
          <article className="about-card">
            <h3>Education</h3>
            <p><strong>University of Birmingham</strong> — BSc Computer Science with Honours, Class II (Division I)</p>
            <p>September 2023 – July 2026</p>
            <p><strong>Relevant modules:</strong> Data Structures & Algorithms, Object-Oriented Programming, Functional Programming, Full Stack Application Development, Software Engineering, Operating Systems and Systems Programming, Security & Networks, Advanced Networking, Artificial Intelligence, Natural Language Processing, Computer Vision.</p>

            <hr />

            <p><strong>Cowbridge School — A-levels</strong></p>
            <p>September 2021 – July 2023</p>
            <p><strong>Grades:</strong> Computer Science A*, Mathematics A*, Physics A*</p>
          </article>

          <article className="about-card">
            <h3>Experience</h3>
            <div className="exp-item">
              <h4>Cashier — SPAR, Llantwit Major</h4>
              <p className="muted">January 2023 – September 2023</p>
              <ul>
                <li>Managed cash handling and point-of-sale transactions in a busy retail environment.</li>
                <li>Resolved customer queries professionally while maintaining efficient service during peak hours.</li>
                <li>Stocked and organised inventory, and maintained store presentation.</li>
              </ul>
            </div>

            <div className="exp-item">
              <h4>Waiter — The Victoria Inn, Sigingstone</h4>
              <p className="muted">May 2021 – October 2022</p>
              <ul>
                <li>Delivered attentive customer service, taking orders and serving meals.</li>
                <li>Prepared tables and supported a smooth dining experience during busy shifts.</li>
              </ul>
            </div>

            <div className="exp-item">
              <h4>Barista — The Corner by SITI, Llantwit Major</h4>
              <p className="muted">February 2021 – September 2021</p>
              <ul>
                <li>Prepared high-quality beverages consistently under pressure and handled transactions.</li>
                <li>Mentored new staff on preparation standards and customer service.</li>
              </ul>
            </div>
          </article>

          <article className="about-card">
            <h3>Interests & Activities</h3>
            <ul>
              <li><strong>Tae Kwon Do:</strong> Trained 7 years; achieved 1st KUP Grade, Black Belt with Red Stripe.</li>
              <li><strong>Rugby:</strong> Played for Cowbridge Rugby Team; participated in tournaments and charity runs.</li>
              <li><strong>Coding & Self-study:</strong> Regularly solve algorithmic problems on LeetCode and follow CS updates.</li>
              <li><strong>Basketball:</strong> Enjoy playing and watching basketball.</li>
            </ul>
          </article>
        </div>

        <aside className="about-aside">
          <div className="about-card">
            <h3>Technical Skills</h3>
            {skills.map((g) => (
              <div key={g.category} className="skill-group">
                <h4>{g.category}</h4>
                <ul className="skill-chips">
                  {g.items.map((i) => (
                    <li key={i}>{i}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </aside>
      </section>
      </div>
    </main>
  )
}

export default AboutPage
